import { Record, Union } from "../../../fable_modules/fable-library-js.4.19.0/Types.js";
import { record_type, option_type, string_type, union_type, obj_type } from "../../../fable_modules/fable-library-js.4.19.0/Reflection.js";
import { UserSession_$reflection, GlobalMsg_$reflection } from "../../../../Bfs.Web.Portale/Types.fs.js";
import { Cmd_none } from "../../../fable_modules/Fable.Elmish.4.2.0/cmd.fs.js";
import { some } from "../../../fable_modules/fable-library-js.4.19.0/Option.js";

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Callback", "GlobalMsg"];
    }
}

export function Msg_$reflection() {
    return union_type("Dashboard.Types.Msg", [], Msg, () => [[["Item", obj_type]], [["Item", GlobalMsg_$reflection()]]]);
}

export class Model extends Record {
    constructor(UserName, UserSession, MostRecentCallback) {
        super();
        this.UserName = UserName;
        this.UserSession = UserSession;
        this.MostRecentCallback = MostRecentCallback;
    }
}

export function Model_$reflection() {
    return record_type("Dashboard.Types.Model", [], Model, () => [["UserName", string_type], ["UserSession", option_type(UserSession_$reflection())], ["MostRecentCallback", option_type(obj_type)]]);
}

export function Model_Init_Z52A72C54(session) {
    return [new Model((session == null) ? "" : session.Name, session, undefined), Cmd_none()];
}

export function Model_Update(msg, model) {
    if (msg.tag === 1) {
        return [model, Cmd_none()];
    }
    else {
        return [new Model(model.UserName, model.UserSession, some(msg.fields[0])), Cmd_none()];
    }
}

//# sourceMappingURL=Types.fs.js.map
